import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=ce96dddc&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=ce96dddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce96dddc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce96dddc')) {
      api.createRecord('ce96dddc', component.options)
    } else {
      api.reload('ce96dddc', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=ce96dddc&scoped=true&", function () {
      api.rerender('ce96dddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zkBf8K3p8CQo/JS/comp/CookieBox.vue"
export default component.exports